import moment from 'moment';

const CUSTOM_LOCALE = 'es-PR';

export const date = (value) => {
  if (value == undefined || value == '') return '-';

  let result = moment(value)
    .locale(CUSTOM_LOCALE)
    .format('DD/MMM/YYYY')
    .replace(/ 0(?:0)?/, ' ');

  return result;
};

export const hour = (value) => {
  if (value == undefined || value == '') return '-';

  let result = moment(value)
    .locale(CUSTOM_LOCALE)
    .utcOffset('-0400')
    .format('hh:mm a');

  return result;
};

export const capitalize = (value) => {
  if (!value) return '';
  value = value.toString();

  return value
    .toLowerCase()
    .split(' ')
    .map((w) => w.substring(0, 1).toUpperCase() + w.substring(1))
    .join(' ');
};

export const datetime = (value) => {
  if (value == undefined || value == '') return '-';

  let result = moment(value)
    .locale(CUSTOM_LOCALE)
    .utcOffset('-0400')
    .format('DD/MMM/YYYY hh:mm a');

  return result;
};

export const phone = (value) => {
  if (value == undefined || value == '') return '-';

  return value
    .replace(/[^0-9]/g, '')
    .replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3');
};

export const upper = (value) => {
  if (value == undefined || value == '') return '';

  return value.toUpperCase();
};

export const empty = (value) => {
  if (value == undefined || value == '') return '-';

  return value;
};
